export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const SET_USER = 'SET_USER';
export const UNAUTHENTICATE_USER = 'UNAUTHENTICATE_USER';
export const UNSET_USER = 'UNSET_USER';
export const TOGGLE_LOGGING_IN_STATE = 'TOGGLE_LOGGING_IN_STATE';

export const SET_INTENDED_ROUTE = 'SET_INTENDED_ROUTE';
export const CLEAR_INTENDED_ROUTE = 'CLEAR_INTENDED_ROUTE';

export const SET_OWNERS = 'SET_OWNERS';

export const SET_CUSTOMER_CURRENT_PAGE = 'SET_CUSTOMER_CURRENT_PAGE';
export const SET_CUSTOMER_PAGE = 'SET_CUSTOMER_PAGE';
export const APPEND_CUSTOMER_PAGE = 'APPEND_CUSTOMER_PAGE';
export const SET_CUSTOMER_PAGE_SIZE = 'SET_CUSTOMER_PAGE_SIZE';
export const SET_CUSTOMER_ORDER_BY = 'SET_CUSTOMER_ORDER_BY';
export const SET_CUSTOMER_SORT_DIRECTION = 'SET_CUSTOMER_SORT_DIRECTION';
export const SET_CUSTOMER_SEARCH = 'SET_CUSTOMER_SEARCH';
export const SET_CUSTOMER_ENQUIRIES = 'SET_CUSTOMER_ENQUIRIES';
export const SET_CUSTOMER_ACTIVITY = 'SET_CUSTOMER_ACTIVITY';
export const SET_CUSTOMER_ANSWER_SET = 'SET_CUSTOMER_ANSWER_SET';
export const SET_CUSTOMER_PAGE_FILTERS = 'SET_CUSTOMER_PAGE_FILTERS';
export const SET_CUSTOMER_PAGE_FROM_DATE = 'SET_CUSTOMER_PAGE_FROM_DATE';
export const SET_CUSTOMER_PAGE_TO_DATE = 'SET_CUSTOMER_PAGE_TO_DATE';
export const SET_CUSTOMER_PAGE_FUNDING_MINIMUM = 'SET_CUSTOMER_PAGE_FUNDING_MINIMUM';
export const SET_CUSTOMER_PAGE_FUNDING_MAXIMUM = 'SET_CUSTOMER_PAGE_FUNDING_MAXIMUM';
export const TOGGLE_CUSTOMER_PAGE_FILTER = 'TOGGLE_CUSTOMER_PAGE_FILTER';
export const REMOVE_ENQUIRY_STATUS_FILTER = 'REMOVE_ENQUIRY_STATUS_FILTER';
export const ADD_ENQUIRY_STATUS_FILTER = 'ADD_ENQUIRY_STATUS_FILTER';
export const REMOVE_REFERRAL_ENQUIRY_STATUS_FILTER = 'REMOVE_REFERRAL_ENQUIRY_STATUS_FILTER';
export const ADD_REFERRAL_ENQUIRY_STATUS_FILTER = 'ADD_REFERRAL_ENQUIRY_STATUS_FILTER';
export const ADD_ANSWER_FILTER = 'ADD_ANSWER_FILTER';
export const REMOVE_ANSWER_FILTER = 'REMOVE_ANSWER_FILTER';
export const ADD_OWNER_FILTER = 'ADD_OWNER_FILTER';
export const REMOVE_OWNER_FILTER = 'REMOVE_OWNER_FILTER';
export const ADD_REFERRAL_OWNER_FILTER = 'ADD_REFERRAL_OWNER_FILTER';
export const REMOVE_REFERRAL_OWNER_FILTER = 'REMOVE_REFERRAL_OWNER_FILTER';
export const RESET_CUSTOMER_TOTAL = 'RESET_CUSTOMER_TOTAL';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const UPDATE_SELECTED_CUSTOMER = 'UPDATE_SELECTED_CUSTOMER';
export const UPDATE_COMPLETION_PERCENTAGE = 'UPDATE_COMPLETION_PERCENTAGE';
export const UPDATE_ACTIVE_JOURNEY = 'UPDATE_ACTIVE_JOURNEY';
export const POST_CUSTOMER_COMMENT = 'POST_CUSTOMER_COMMENT';
export const SET_CUSTOMER_DOCUMENTS = 'SET_CUSTOMER_DOCUMENTS';
export const MAKE_CUSTOMER_ENQUIRY = 'MAKE_CUSTOMER_ENQUIRY';
export const SET_CUSTOMER_ENQUIRY = 'SET_CUSTOMER_ENQUIRY';
export const SET_CUSTOMER_ENQUIRY_FEE = 'SET_CUSTOMER_ENQUIRY_FEE';
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';
export const SET_FUNDED_CUSTOMERS = 'SET_FUNDED_CUSTOMERS';
export const RESET_CUSTOMER_FILTERS = 'RESET_CUSTOMER_FILTERS';
export const SET_CUSTOMER_QUERY_ERROR = 'SET_CUSTOMER_QUERY_ERROR';
export const REMOVE_CUSTOMER_DOCUMENT = 'REMOVE_CUSTOMER_DOCUMENT';
export const SET_CUSTOMERS_SCROLL_POSITION = 'SET_CUSTOMERS_SCROLL_POSITION';

export const SET_FUNDER_CURRENT_PAGE = 'SET_FUNDER_CURRENT_PAGE';
export const RESET_FUNDER_TOTAL = 'RESET_FUNDER_TOTAL';
export const SET_FUNDER_ENQUIRIES = 'SET_FUNDER_ENQUIRIES';
export const APPEND_FUNDER_ENQUIRIES = 'APPEND_FUNDER_ENQUIRIES';
export const SET_FUNDER_ENQUIRY_PAGE_FROM_DATE = 'SET_FUNDER_ENQUIRY_PAGE_FROM_DATE';
export const SET_FUNDER_ENQUIRY_PAGE_TO_DATE = 'SET_FUNDER_ENQUIRY_PAGE_TO_DATE';
export const SET_FUNDER_ENQUIRY_PAGE_FUNDING_MINIMUM = 'SET_FUNDER_ENQUIRY_PAGE_FUNDING_MINIMUM';
export const SET_FUNDER_ENQUIRY_PAGE_FUNDING_MAXIMUM = 'SET_FUNDER_ENQUIRY_PAGE_FUNDING_MAXIMUM';
export const ADD_FUNDER_ENQUIRY_STATUS_FILTER = 'ADD_FUNDER_ENQUIRY_STATUS_FILTER';
export const REMOVE_FUNDER_ENQUIRY_STATUS_FILTER = 'REMOVE_FUNDER_ENQUIRY_STATUS_FILTER';
export const SET_FUNDER_ENQUIRY_SEARCH = 'SET_FUNDER_ENQUIRY_SEARCH';
export const UPDATE_FUNDER_ENQUIRY = 'UPDATE_FUNDER_ENQUIRY';
export const SET_FUNDER_SEARCH = 'SET_FUNDER_SEARCH';
export const SET_FUNDER_JOURNEY_FILTER = 'SET_FUNDER_JOURNEY_FILTER';
export const SET_FUNDER_INCLUDE_DISABLED = 'SET_FUNDER_INCLUDE_DISABLED';
export const SET_FUNDER_API_PROPERTIES = 'SET_FUNDER_API_PROPERTIES';
export const ADD_FUNDER_API_PROPERTIES = 'ADD_FUNDER_API_PROPERTIES';
export const REMOVE_FUNDER_API_PROPERTIES = 'REMOVE_FUNDER_API_PROPERTIES';
export const SET_SELECTED_FUNDER_ENQUIRY_TAB = 'SET_SELECTED_FUNDER_ENQUIRY_TAB';
export const SET_REFERRAL_ENQUIRIES = 'SET_REFERRAL_ENQUIRIES';

export const SET_ENQUIRY_STATUS_LIST = 'SET_ENQUIRY_STATUS_LIST';
export const SET_ENQUIRY_PAGE_SIZE = 'SET_ENQUIRY_PAGE_SIZE';
export const SET_ENQUIRY_ORDER_BY = 'SET_ENQUIRY_ORDER_BY';
export const SET_ENQUIRY_SORT_DIRECTION = 'SET_ENQUIRY_SORT_DIRECTION';
export const SET_ENQUIRY_FILTERS = 'SET_ENQUIRY_FILTERS';
export const SET_ENQUIRY_LOADING_STATE = 'SET_ENQUIRY_LOADING_STATE';
export const REMOVE_ENQUIRY_FILTERS = 'REMOVE_ENQUIRY_FILTERS';
export const REMOVE_ENQUIRY_FROM_LIST = 'REMOVE_ENQUIRY_FROM_LIST';
export const SELECT_ENQUIRY = 'SELECT_ENQUIRY';
export const UPDATE_FUNDER_SELECTED_ENQUIRY = 'UPDATE_FUNDER_SELECTED_ENQUIRY';
export const SET_ENQUIRIES_CURRENT_PAGE = 'SET_ENQUIRIES_CURRENT_PAGE';
export const RESET_ENQUIRIES_TOTAL = 'RESET_ENQUIRIES_TOTAL';

export const START_LOADING_CUSTOMER = 'START_LOADING_CUSTOMER';
export const STOP_LOADING_CUSTOMER = 'STOP_LOADING_CUSTOMER';

export const START_LOADING_PRODUCTS = 'START_LOADING_PRODUCTS';
export const STOP_LOADING_PRODUCTS = 'STOP_LOADING_PRODUCTS';

export const TOGGLE_LEFT_DRAWER = 'TOGGLE_LEFT_DRAWER';

export const SET_BILLABLE_ENQUIRIES = 'SET_BILLABLE_ENQUIRIES';
export const APPEND_BILLABLE_ENQUIRIES = 'APPEND_BILLABLE_ENQUIRIES';
export const SET_BILLABLE_ENQUIRIES_CURRENT_PAGE = 'SET_BILLABLE_ENQUIRIES_CURRENT_PAGE';
export const SET_BILLABLE_ENQUIRIES_PAGE_SIZE = 'SET_BILLABLE_ENQUIRIES_PAGE_SIZE';
export const RESET_BILLABLE_ENQUIRIES_TOTAL = 'RESET_BILLABLE_ENQUIRIES_TOTAL';
export const SET_BILLABLE_ENQUIRY_FROM_DATE = 'SET_BILLABLE_ENQUIRY_FROM_DATE';
export const SET_BILLABLE_ENQUIRY_TO_DATE = 'SET_BILLABLE_ENQUIRY_TO_DATE';
export const SET_BILLABLE_ENQUIRY_DATE_COLUMN = 'SET_BILLABLE_ENQUIRY_DATE_COLUMN';
export const SET_BILLABLE_ENQUIRY_SEARCH = 'SET_BILLABLE_ENQUIRY_SEARCH';
export const SET_BILLABLE_ENQUIRY_STATUS = 'SET_BILLABLE_ENQUIRY_STATUS';
export const SET_BILLABLE_LOADING_STATE = 'SET_BILLABLE_LOADING_STATE';
export const SET_BILLABLE_SORT_ORDER = 'SET_BILLABLE_SORT_ORDER';
export const ADD_BILL_TO_BILLABLE_ENQUIRY = 'ADD_BILL_TO_BILLABLE_ENQUIRY';
export const SET_UPDATE_BILL = 'SET_UPDATE_BILL';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

export const STORE_ANSWER_SET = 'STORE_ANSWER_SET';
export const UPDATE_ANSWER_SET = 'UPDATE_ANSWER_SET';

export const UPDATE_PRODUCT_COLOURS = 'UPDATE_PRODUCT_COLOURS';
export const TOGGLE_PRODUCT_SELECT = 'TOGGLE_PRODUCT_SELECT';
export const SET_PRODUCT_SET = 'SET_PRODUCT_SET';
export const SET_UPDATE_PRODUCT = 'SET_UPDATE_PRODUCT';
export const REMOVE_PRODUCT_FROM_PRODUCT_SET = 'REMOVE_PRODUCT_FROM_PRODUCT_SET';
export const SET_PRODUCT_TIERS = 'SET_PRODUCT_TIERS';
export const SET_PRODUCT_CONTENT = 'SET_PRODUCT_CONTENT';

export const SET_REGISTRATION_CONTACT = 'SET_REGISTRATION_CONTACT';
export const SET_REGISTRATION_BUSINESS = 'SET_REGISTRATION_BUSINESS';
export const SET_REGISTRATION_REFERRER_LIST = 'SET_REGISTRATION_REFERRER_LIST';
export const SET_REGISTRATION_EMAIL_EXISTS = 'SET_REGISTRATION_EMAIL_EXISTS';
export const SET_REGISTRATION_EXPERIAN_LIST = 'SET_REGISTRATION_EXPERIAN_LIST';
export const SET_REGISTRATION_BUSINESS_EXISTS = 'SET_REGISTRATION_BUSINESS_EXISTS';
export const SET_REGISTERING_FLAG = 'SET_REGISTERING_FLAG';
export const SET_SEARCHING_EXPERIAN_FLAG = 'SET_SEARCHING_EXPERIAN_FLAG';
export const CLEAR_REGISTRATION = 'CLEAR_REGISTRATION';
export const SET_REGISTRATION_QUESTION_COUNT = 'SET_REGISTRATION_QUESTION_COUNT';
export const SET_REGISTRATION_ANSWER = 'SET_REGISTRATION_ANSWER';

export const SET_FUNDERS_LIST = 'SET_FUNDERS_LIST';
export const SET_SELECTED_FUNDER = 'SET_SELECTED_FUNDER';
export const SELECT_FUNDER_USER = 'SELECT_FUNDER_USER';
export const SET_SELECTED_FUNDER_IN_LIST = 'SET_SELECTED_FUNDER_IN_LIST';

export const SET_QUESTIONS = 'SET_QUESTIONS';
export const SET_SELECTED_QUESTION = 'SET_SELECTED_QUESTION';
export const UNSET_SELECTED_QUESTION = 'UNSET_SELECTED_QUESTION';
export const UPDATE_QUESTION_ORDER = 'UPDATE_QUESTION_ORDER';
export const SET_QUESTION_TYPES = 'SET_QUESTION_TYPES';
export const SET_QUESTION_PRODUCT_LIST = 'SET_QUESTION_PRODUCT_LIST';
export const UPDATE_COLOUR = 'UPDATE_COLOUR';
export const UPDATE_ANSWER = 'UPDATE_ANSWER';
export const SET_SELECTED_ANSWER = 'SET_SELECTED_ANSWER';
export const SET_SELECTED_ANSWER_QUESTION_ID = 'SET_SELECTED_ANSWER_QUESTION_ID';
export const SET_SELECTED_ANSWER_VALUE = 'SET_SELECTED_ANSWER_VALUE';
export const SET_SELECTED_ANSWER_LABEL = 'SET_SELECTED_ANSWER_LABEL';
export const SET_SELECTED_ANSWER_BBB_VALUE = 'SET_SELECTED_ANSWER_BBB_VALUE';
export const SET_SELECTED_ANSWER_ENABLED = 'SET_SELECTED_ANSWER_ENABLED';
export const SET_SELECTED_ANSWER_WARNING_MESSAGE = 'SET_SELECTED_ANSWER_WARNING_MESSAGE';

export const SET_JOURNEYS = 'SET_JOURNEYS';
export const SET_SELECTED_JOURNEY = 'SET_SELECTED_JOURNEY';
export const UNSET_SELECTED_JOURNEY = 'UNSET_SELECTED_JOURNEY';
export const UPDATE_SELECTED_JOURNEY_CRITERIA = 'UPDATE_SELECTED_JOURNEY_CRITERIA';
export const UPDATE_JOURNEY = 'UPDATE_JOURNEY';

export const SET_JOURNEY_TYPES = 'SET_JOURNEY_TYPES';
export const SET_SELECTED_JOURNEY_TYPE = 'SET_SELECTED_JOURNEY_TYPE';

export const SET_GROUPS = 'SET_GROUPS';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const UNSET_SELECTED_GROUP = 'UNSET_SELECTED_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const UPDATE_GROUP_ORDER = 'UPDATE_GROUP_ORDER';

export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';

export const SET_CONTENTS = 'SET_CONTENTS';
export const SET_CONTENT_SEARCH = 'SET_CONTENT_SEARCH';

export const SET_BANKS_LIST = 'SET_BANKS_LIST';
export const SET_SELECTED_BANK = 'SET_SELECTED_BANK';

export const SET_PLATFORMS_LIST = 'SET_PLATFORMS_LIST';
export const SET_SELECTED_PLATFORM = 'SET_SELECTED_PLATFORM';

export const SET_REFERRALS = 'SET_REFERRALS';
export const MAKE_REFERRAL = 'MAKE_REFERRAL';
export const SET_REFERRAL = 'SET_REFERRAL';
export const SET_REFERRAL_PAGE_SIZE = 'SET_REFERRAL_PAGE_SIZE';
export const SET_REFERRAL_PAGE_FROM_DATE = 'SET_REFERRAL_PAGE_FROM_DATE';
export const SET_REFERRAL_PAGE_TO_DATE = 'SET_REFERRAL_PAGE_TO_DATE';
export const SET_REFERRAL_PAGE_FUNDING_MINIMUM = 'SET_REFERRAL_PAGE_FUNDING_MINIMUM';
export const SET_REFERRAL_PAGE_FUNDING_MAXIMUM = 'SET_REFERRAL_PAGE_FUNDING_MAXIMUM';
export const SET_REFERRAL_ORDER_BY = 'SET_REFERRAL_ORDER_BY';
export const SET_REFERRAL_SORT_DIRECTION = 'SET_REFERRAL_SORT_DIRECTION';
export const SET_REFERRAL_FILTERS = 'SET_REFERRAL_FILTERS';
export const SET_REFERRAL_LOADING_STATE = 'SET_REFERRAL_LOADING_STATE';
export const SET_REFERRAL_SEARCH = 'SET_REFERRAL_SEARCH';
export const SELECT_REFERRAL = 'SELECT_REFERRAL';
export const SET_REFERRAL_ACTIVITY = 'SET_REFERRAL_ACTIVITY';
export const SET_REFERRER_ID = 'SET_REFERRER_ID';
export const SET_UPDATE_REFERRAL = 'SET_UPDATE_REFERRAL';
export const POST_REFERRAL_COMMENT = 'POST_REFERRAL_COMMENT';
export const SET_REFERRAL_UPLOADS = 'SET_REFERRAL_UPLOADS';
export const CLEAR_REFERRAL_UPLOADS = 'CLEAR_REFERRAL_UPLOADS';
export const SET_REFERRAL_DOCUMENTS = 'SET_REFERRAL_DOCUMENTS';
export const SET_REFERRAL_DOWNLOADING_STATE = 'SET_REFERRAL_DOWNLOADING_STATE';
export const SET_REFERRAL_CURRENT_PAGE = 'SET_REFERRAL_CURRENT_PAGE';
export const APPEND_REFERRAL_PAGE = 'APPEND_REFERRAL_PAGE';
export const SET_REFERRAL_PAGE = 'SET_REFERRAL_PAGE';
export const RESET_REFERRAL_TOTAL = 'RESET_REFERRAL_TOTAL';
export const TOGGLE_REFERRAL_PAGE_FILTER = 'TOGGLE_REFERRAL_PAGE_FILTER';
export const START_LOADING_REFERRAL = 'START_LOADING_REFERRAL';
export const STOP_LOADING_REFERRAL = 'STOP_LOADING_REFERRAL';
export const RESET_REFERRAL_FILTERS = 'RESET_REFERRAL_FILTERS';
export const CLEAR_SELECTED_REFERRAL = 'CLEAR_SELECTED_REFERRAL';
export const SET_REFERRALS_SCROLL_POSITION = 'SET_REFERRALS_SCROLL_POSITION';

export const SET_BBB_PRODUCT_TERMS = 'SET_BBB_PRODUCT_TERMS';
export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES';
export const SET_SELECTED_PRODUCT_TYPE = 'SET_SELECTED_PRODUCT_TYPE';
export const ADD_PRODUCT_TYPE = 'ADD_PRODUCT_TYPE';
export const SET_UPDATE_PRODUCT_TYPE = 'SET_UPDATE_PRODUCT_TYPE';
export const REMOVE_PRODUCT_TYPE = 'REMOVE_PRODUCT_TYPE';

export const SET_FEE_TIERS = 'SET_FEE_TIERS';
export const SET_UPDATE_FEE_TIER = 'SET_UPDATE_FEE_TIER';

export const SET_PARTNERS_LIST = 'SET_PARTNERS_LIST';
export const SET_PARTNERS_INCLUDE_DISABLED = 'SET_PARTNERS_INCLUDE_DISABLED';
export const SET_PARTNER_SEARCH = 'SET_PARTNER_SEARCH';
export const SELECT_PARTNER = 'SELECT_PARTNER';
export const SET_PARTNER_CHILDREN = 'SET_PARTNER_CHILDREN';
export const SET_SELECTED_PARTNER_CHILD = 'SET_SELECTED_PARTNER_CHILD';
export const SET_SELECTED_PARTNER_IN_LIST = 'SET_SELECTED_PARTNER_IN_LIST';
export const SET_FUNDER_COMPANIES = 'SET_FUNDER_COMPANIES';
export const CLEAR_SELECTED_PARTNER = 'CLEAR_SELECTED_PARTNER';

export const SET_BROKERS_LIST = 'SET_BROKERS_LIST';
export const SET_BROKER_SEARCH = 'SET_BROKER_SEARCH';
export const SELECT_BROKER = 'SELECT_BROKER';
export const SET_SELECTED_BROKER_IN_LIST = 'SET_SELECTED_BROKER_IN_LIST';

export const UI_ENABLE_MENU_OPTION = 'UI_ENABLE_MENU_OPTION';
export const UI_ENABLE_FILTER_OPTION = 'UI_ENABLE_FILTER_OPTION';

export const SET_ACCOUNTS_PAGE = 'SET_ACCOUNTS_PAGE';
export const APPEND_ACCOUNTS_PAGE = 'APPEND_ACCOUNTS_PAGE';
export const SET_ACCOUNTS_CURRENT_PAGE = 'SET_ACCOUNTS_CURRENT_PAGE';
export const SET_SELECTED_ACCOUNT_IN_LIST = 'SET_SELECTED_ACCOUNT_IN_LIST';
export const RESET_ACCOUNTS_TOTAL = 'RESET_ACCOUNTS_TOTAL';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const UPDATE_SELECTED_ACCOUNT = 'UPDATE_SELECTED_ACCOUNT';
export const SET_ACCOUNT_SEARCH = 'SET_ACCOUNT_SEARCH';
export const ADD_ACCOUNT_FILTER = 'ADD_ACCOUNT_FILTER';
export const REMOVE_ACCOUNT_FILTER = 'REMOVE_ACCOUNT_FILTER';
export const REMOVE_ALL_ACCOUNT_FILTERS = 'REMOVE_ALL_ACCOUNT_FILTERS';

export const RESET_ACCOUNT_LIST = 'RESET_ACCOUNT_LIST';
export const START_LOADING_ACCOUNTS = 'START_LOADING_ACCOUNTS';
export const STOP_LOADING_ACCOUNTS = 'STOP_LOADING_ACCOUNTS';
export const UPDATE_SELECTED_ACCOUNT_USER = 'UPDATE_SELECTED_ACCOUNT_USER';
export const SET_BUSINESS_TYPES = 'SET_BUSINESS_TYPES';

export const SET_PLATFORM_DASHBOARD_DATA = 'SET_PLATFORM_DASHBOARD_DATA';
export const SET_PARTNER_DASHBOARD_DATA = 'SET_PARTNER_DASHBOARD_DATA';
export const SET_FUNDER_DASHBOARD_DATA = 'SET_FUNDER_DASHBOARD_DATA';
export const SET_DASHBOARD_DATA_LOADING = 'SET_DASHBOARD_DATA_LOADING';

export const SET_ACTIVITY_COMMENTS = 'SET_ACTIVITY_COMMENTS';
export const CLEAR_ACTIVITY_COMMENTS = 'CLEAR_ACTIVITY_COMMENTS';
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';
export const LOAD_ACTIVITY_COMMENTS = 'LOAD_ACTIVITY_COMMENTS';
export const INSERT_ACTIVITY_COMMENT = 'INSERT_ACTIVITY_COMMENT';

export const SET_PROVIDERS = 'SET_PROVIDERS';

export const GET_ADVERTS = 'GET_ADVERTS';
export const SET_SELECTED_ADVERT = 'SET_SELECTED_ADVERT';
export const CREATE_ADVERT = 'CREATE_ADVERT';
export const UPDATE_ADVERT = 'UPDATE_ADVERT';
export const GET_ADVERT_EXCLUSIONS = 'GET_ADVERT_EXCLUSIONS';
export const ADVERT_EXCLUDE_PARTNER = 'ADVERT_EXCLUDE_PARTNER';
export const ADVERT_INCLUDE_PARTNER = 'ADVERT_INCLUDE_PARTNER';

export const SET_DIALLER_QUEUES = 'SET_DIALLER_QUEUES';
export const SET_DIALLER_CALLS = 'SET_DIALLER_QUEUE';
export const SELECT_DIALLER_QUEUE = 'SELECT_DIALLER_QUEUE';
export const ADD_CALL_TO_QUEUE = 'ADD_CALL_TO_QUEUE';
export const REMOVE_CALL_FROM_QUEUE = 'REMOVE_CALL_FROM_QUEUE';
export const SELECT_PHONE_CALL = 'SELECT_PHONE_CALL';
export const SET_PHONE_CALL_AS_REGISTERED = 'SET_PHONE_CALL_AS_REGISTERED';
export const SET_PHONE_CALL_OUTCOMES = 'SET_PHONE_CALL_OUTCOMES';
export const SET_ACTIVE_CALL = 'SET_ACTIVE_CALL';
export const CLEAR_ACTIVE_CALL = 'CLEAR_ACTIVE_CALL';
export const UPDATE_ACTIVE_CALL = 'UPDATE_ACTIVE_CALL';
export const MARK_PHONE_CALL_OVERDUE = 'MARK_PHONE_CALL_OVERDUE';

export const SET_IMPORTS = 'SET_IMPORTS';
export const SET_IMPORT_FILE = 'SET_IMPORT_FILE';

export const SET_TWILIO_DEVICE = 'SET_TWILIO_DEVICE';
export const SELECT_TWILIO_INPUT_DEVICE = 'SELECT_INPUT_DEVICE';
export const SELECT_TWILIO_OUTPUT_SPEAKER_DEVICE = 'SELECT_OUTPUT_SPEAKER_DEVICE';
export const SELECT_TWILIO_OUTPUT_RINGTONE_DEVICE = 'SELECT_OUTPUT_RINGTONE_DEVICE';
export const SET_TWILIO_DEVICE_MUTE = 'SET_TWILIO_DEVICE_MUTE';
export const SET_TWILIO_ON_PHONE_STATE = 'SET_TWILIO_ON_PHONE_STATE';
export const SET_TWILIO_OFFLINE_STATE = 'SET_TWILIO_OFFLINE_STATE';
export const SET_TWILIO_CONNECTION = 'SET_TWILIO_CONNECTION';

export const ADD_HTTP_REQUEST = 'ADD_HTTP_REQUEST';
export const REMOVE_HTTP_REQUEST = 'REMOVE_HTTP_REQUEST';
export const SHOW_REFRESH_WARNING = 'SHOW_REFRESH_WARNING';
export const HIDE_REFRESH_WARNING = 'HIDE_REFRESH_WARNING';

export const SET_LOADING_REPORTS_STATE = 'SET_LOADING_REPORTS_STATE';
export const SET_REPORTS_LIST = 'SET_REPORTS_LIST';
